import { connect } from 'react-redux';
import BookingPhase from './BookingPhase';

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingPhase);



// WEBPACK FOOTER //
// ./src/components/BookingPhase/index.js